import React from 'react'
import { Box } from '@chakra-ui/react'

const Overlay = props => {
  return (
    <Box
      position="absolute"
      top={0}
      bottom={0}
      right={0}
      left={0}
      width="full"
      height="full"
      zIndex={1}
      {...props}
    />
  )
}

Overlay.defaultProps = {
  bg: 'black',
  opacity: '0.5',
}

Overlay.displayName = 'Overlay'

export default Overlay
